import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { BsbService } from '../../services/bsb/bsb.service';
import { BankDetails } from '../../interfaces/bankDetails';

@Component({
  selector: 'app-bsb[formControl]',
  templateUrl: './bsb.component.html',
  styleUrls: ['./bsb.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BsbComponent),
      multi: true,
    },
  ],
})
export class BsbComponent implements ControlValueAccessor {
  @Input() formControl: FormControl;

  @Input() placeholder?: string;

  bankDetails?: BankDetails = undefined;

  showSpinner: boolean = false;

  constructor(private bsbService: BsbService) {}

  searchBSB() {
    if (!this.formControl?.valid || this.formControl?.value.length < 6) {
      this.bankDetails = undefined;
      return;
    }
    this.showSpinner = true;
    this.bsbService.verifyBsb(this.formControl?.value).subscribe({
      next: (response) => {
        if (response?.message?.bankname) {
          this.bankDetails = response;
        } else {
          this.bankDetails = undefined;
          this.setBSBError();
        }

        this.showSpinner = false;
      },
      error: () => {
        this.bankDetails = undefined;
        this.setBSBError();
        this.showSpinner = false;
      },
    });
  }

  setBSBError() {
    this.formControl?.setErrors({ invalidBSB: true });
    this.formControl?.markAsTouched();
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();

    const pastedData = event.clipboardData?.getData('text/plain');

    const strippedValue = pastedData
      ?.replace(/\s+/g, '')
      .replace(/\D/g, '')
      .slice(0, 6);

    this.formControl?.setValue(strippedValue ?? '');
    this.onChange(strippedValue ?? '');
    this.formControl?.updateValueAndValidity();
    this.searchBSB();
  }

  onChange = (value: any) => {};

  onTouched = () => {};

  writeValue(value: any): void {
    if (this.formControl && value && value !== this.formControl.value) {
      this.formControl.setValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
